// @flow

import React from 'react';
import { observer } from 'mobx-react-lite';

import styled from '@emotion/styled';

import pluralize from 'pluralize';

import Title from '@vromo/ui/components/Title';
import { InfoCard } from './InfoCard';
import Container from '@vromo/ui/components/Container';

import JobSummaryChart from './JobSummaryChart';
import TopTeams from './TopTeams';
import { JobStats } from './DashboardRoot.lazy';

const SegmentRow = styled.div`
    display: flex;
    align-content: stretch;
    flex-shrink: 0;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`;

type Props = {
    jobStats: JobStats | Record<string, never>;
    loading: boolean;
};

export default observer(function GeneralStats({
    jobStats,
    loading
}: Props | Record<string, never>) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
                style={{
                    display: 'flex',
                    flexShrink: 0,
                    alignItems: 'center',
                    marginLeft: '20px'
                }}>
                <Title>Past 24 Hours</Title>
            </div>
            <SegmentRow>
                <InfoCard
                    icon="clipboard-list-check"
                    colour="#43C96E"
                    quantity={loading ? '-' : jobStats?.jobsCompleted}
                    label={`${pluralize('Job', jobStats?.jobsCompleted)} Completed`}
                />
                <InfoCard
                    icon="ban"
                    colour="#FF4444"
                    quantity={loading ? '-' : jobStats?.jobsCancelled}
                    label={`${pluralize('Job', jobStats?.jobsCancelled)} Cancelled`}
                />
                <InfoCard
                    icon="bullseye-pointer"
                    colour="#6D55CC"
                    quantity={loading ? '-' : jobStats?.linksOpened}
                    label={`Tracking ${pluralize('Link', jobStats?.linksOpened)} Opened`}
                />
                <InfoCard
                    icon="stopwatch"
                    colour="#1590CE"
                    quantity={loading ? '-' : jobStats?.completedOnTime}
                    label="Completed On Time"
                />
            </SegmentRow>
            <SegmentRow>
                <Container title="Top Teams" style={{ flex: 1, margin: 20 }}>
                    <TopTeams jobStats={jobStats} />
                </Container>
                <Container title="Job Summary" style={{ flex: 1, margin: 20, minHeight: 450 }}>
                    <JobSummaryChart jobStats={jobStats} />
                </Container>
            </SegmentRow>
        </div>
    );
});
